import { useId } from "react";
import { TRUST_COLOR, BETRAY_COLOR } from "../theme";

// Lucide's "sword" path data, rendered twice and clipped down the middle so
// the blade reads as two-tone: orange on the left, blue on the right.
function DaggerPaths() {
  return (
    <>
      <path d="m11 19-6-6" />
      <path d="m5 21-2-2" />
      <path d="m8 16-4 4" />
      <path d="M9.5 17.5 21 6V3h-3L6.5 14.5" />
    </>
  );
}

function DaggerIcon({ size = 24, strokeWidth = 2 }) {
  const id = useId();
  const leftClip = `${id}-left`;
  const rightClip = `${id}-right`;

  // Rotating the 18x18 glyph 135deg about its center pushes its corners out
  // to roughly +/-12.7 from center — past the original 0-24 viewBox, which
  // clipped the bottom of the blade. -1 -1 26 26 gives just enough room
  // without leaving a ring of dead space around the glyph.
  return (
    <svg width={size} height={size} viewBox="-1 -1 26 26" fill="none" style={{ display: "block" }}>
      <defs>
        <clipPath id={leftClip}><rect x="-1" y="-1" width="13" height="26" /></clipPath>
        <clipPath id={rightClip}><rect x="12" y="-1" width="13" height="26" /></clipPath>
      </defs>
      <g clipPath={`url(#${leftClip})`}>
        <g transform="rotate(135 12 12)" stroke={BETRAY_COLOR} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <DaggerPaths />
        </g>
      </g>
      <g clipPath={`url(#${rightClip})`}>
        <g transform="rotate(135 12 12)" stroke={TRUST_COLOR} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <DaggerPaths />
        </g>
      </g>
    </svg>
  );
}

export default DaggerIcon;
